import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { priceImprovementMessageReceivedEpic } from './priceImprovementMessageReceivedEpic';
import { priceImprovementRejectEpic } from './priceImprovementRejectEpic';
import { priceImprovementCancelEpic, priceImprovementCreateEpic } from './priceImprovementRequestEpic';
import { priceImprovementValidateEpic } from './priceImprovementValidateEpic';

export const priceImprovementEpic = () =>
  combineEpics(
    withAppCrashIfException('priceImprovementCreateEpic', priceImprovementCreateEpic()),
    withAppCrashIfException('priceImprovementCancelEpic', priceImprovementCancelEpic()),
    withAppCrashIfException('priceImprovementRejectEpic', priceImprovementRejectEpic()),
    withAppCrashIfException('priceImprovementValidateEpic', priceImprovementValidateEpic()),
    withAppCrashIfException('priceImprovementMessageReceivedEpic', priceImprovementMessageReceivedEpic()),
  );
